export const config = {
  baseUrl: process.env.REACT_APP_BASE_URL || 'https://localhost:3000', 
  fileDownloadUrl: process.env.REACT_APP_BASE_URL || 'https://www.pshdemo.com', 
  baseTableauUrl: process.env.REACT_APP_BASE_TABLEAU_URL || 'http://tableau.pshdemo.com',
  timeout: 30000, //not used in code
  https: process.env.HTTPS || false, //not used in code
  gTagID: process.env.REACT_APP_GTAG_ID || 'GTM-WK5H8ZLK,G-PFQYED70LM',
  publicFeedback: true,
  recaptchaV3DevSiteKey: process.env.REACT_APP_RECAPTCHA_V3_SITEKEY || "6LfPH9QsAAAAACbC2NcjcNFfp9xFpbim4kLkzlFW",
  recaptchaBlockingEnabled: false, // Set to true when ready to block content based on scores
  recaptchaScoreThreshold: 0.5, // Minimum score to be considered human
  //Local/Dev/Test: GTM-WK5H8ZLK
  //Prod: GTM-W85XVGBB
  isDebugEnabled: false
};
